import React from "react"
import styled from "styled-components"
import { useTranslations } from "next-intl"

import * as PhoneNumberTools from "~/utilities/phoneNumber"

import TRACKING from "~/services/tracking"
import Phone from "~/public/static/images/png/traffic/landing/phone.png"

const PhoneContainer = styled.a`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: black;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
const PhoneImage = styled.img`
  margin: 0;
`

const PhoneNum = styled.span`
  text-decoration: none;
  margin: 4px;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.avenirNextBold};
  font-size: 1.3rem;
`
const PhoneText = styled.span`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 1.1rem;
  color: red;
`

const SupportPhoneNumber = ({phoneNumber}) => {
  const displayPhoneNumber = PhoneNumberTools.AsYouTypeFormatter(
    phoneNumber
  )

  const translate = useTranslations('header')

  return (
    <PhoneContainer
      href={`tel:+1${phoneNumber}`}
      onClick={TRACKING.traffic.clickedPhoneNumber}
    >
      <PhoneNum>
        <PhoneImage
          src={Phone}
          alt="Call Us"
        />
      </PhoneNum>
      <PhoneNum>
        <PhoneText>{translate('callUs')}</PhoneText>
        {displayPhoneNumber}
      </PhoneNum>
    </PhoneContainer>
  )
}

export default SupportPhoneNumber
